export { default } from './Activation'
export * as S from './Activation.styles'
